// Üst ve sol cetvel (mm). Sıfır noktası = kağıdın kenarı; zoom ve scroll'a duyarlı.
import { PX_PER_MM, RULER_TICK_LABEL } from './rulerConst';
import { RULER } from './designerStyles';

// İşaretleme adımını zoom'a göre seç (ekranda çok sık çizgi olmasın).
function tickStep(zoom) {
  const pxPer10 = 10 * PX_PER_MM * zoom;
  if (pxPer10 < 14) return 50;   // çok küçük zoom → her 50mm
  if (pxPer10 < 30) return 20;
  return 10;                     // her 10mm etiketli
}

function ticks(lengthMm, zoom) {
  const major = tickStep(zoom);
  const minor = major / (major >= 50 ? 5 : 2); // ara işaret
  const out = [];
  for (let mm = 0; mm <= lengthMm + 0.1; mm += minor) {
    const isMajor = Math.abs(mm % major) < 0.001;
    out.push({ mm, px: mm * PX_PER_MM * zoom, major: isMajor });
  }
  return out;
}

export function RulerTop({ originX, lengthMm, zoom }) {
  const list = ticks(lengthMm, zoom);
  return (
    <div style={{ height: RULER, background: 'var(--designer-ruler-bg)', borderBottom: '1px solid var(--border-color)', position: 'relative', overflow: 'hidden' }}>
      {list.map((t, i) => (
        <div key={i} style={{ position: 'absolute', left: originX + t.px, top: 0, bottom: 0 }}>
          <div style={{ position: 'absolute', bottom: 0, left: 0, width: 1, height: t.major ? 9 : 5, background: 'var(--designer-ruler-tick)' }} />
          {t.major && <span style={{ position: 'absolute', top: 2, left: 3, fontSize: RULER_TICK_LABEL, color: 'var(--designer-ruler-text)', whiteSpace: 'nowrap' }}>{Math.round(t.mm)}</span>}
        </div>
      ))}
    </div>
  );
}

export function RulerLeft({ originY, lengthMm, zoom }) {
  const list = ticks(lengthMm, zoom);
  return (
    <div style={{ width: RULER, background: 'var(--designer-ruler-bg)', borderRight: '1px solid var(--border-color)', position: 'relative', overflow: 'hidden' }}>
      {list.map((t, i) => (
        <div key={i} style={{ position: 'absolute', top: originY + t.px, left: 0, right: 0 }}>
          <div style={{ position: 'absolute', right: 0, top: 0, height: 1, width: t.major ? 9 : 5, background: 'var(--designer-ruler-tick)' }} />
          {t.major && <span style={{ position: 'absolute', left: 2, top: 3, fontSize: RULER_TICK_LABEL, color: 'var(--designer-ruler-text)', whiteSpace: 'nowrap', writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}>{Math.round(t.mm)}</span>}
        </div>
      ))}
    </div>
  );
}
